import React from 'react';
// Components
import ClockIcon from 'assets/images/svg/ClockIcon';

const MINUTES_IN_HOUR = 60;

const formatMinutes = (minutes) => {
  const total = Math.abs(minutes);
  return `${Math.floor(total / MINUTES_IN_HOUR)}h ${total % MINUTES_IN_HOUR}m`;
};

/**
 * Time left before the order has to be dispatched. The orders DTO sends it already
 * formatted ("9h 18m"); a plain number of minutes is formatted here.
 */
const CutoffTimer = ({ item }) => {
  const cutoff = item?.dispatchTimeCutoff;

  if (cutoff == null || cutoff === '') {
    return null;
  }

  const value = typeof cutoff === 'number' ? formatMinutes(cutoff) : cutoff;
  const isOverdue = Boolean(item?.isOverdue);

  return (
    <div className="cutoff-timer">
      <span className="cutoff-label">Cut-off timer</span>
      <ClockIcon cssClass={`cutoff-icon${isOverdue ? ' overdue' : ''}`} />
      <span className={`cutoff-value${isOverdue ? ' overdue' : ''}`}>{value}</span>
    </div>
  );
};

export default CutoffTimer;
